var map = {
	"./ActionsModal/Cambio.vue": 800,
	"./ActionsModal/SaveChanges.vue": 801,
	"./ActionsModal/index.vue": 246,
	"./agrocolor.vue": 2050,
	"./araporcei.vue": 2051,
	"./coplaca/ParcelasActionsMultiple.vue": 1119,
	"./coplaca/index.vue": 2052,
	"./default.vue": 2053,
	"./demo.vue": 2054,
	"./sites.vue": 293,
	"./widgets/auditorias.vue": 802,
	"./widgets/dictamenes.vue": 805,
	"./widgets/pacs.vue": 807,
	"./widgets/revisiones.vue": 804,
	"./widgets/solicitudes.vue": 803,
	"./widgets/toma_muestras.vue": 806
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1763;